import styled from '@emotion/styled';
import { Dialog, DialogContent, DialogProps } from '@mui/material';
import { CloseButton } from './components/close-button/close-button';

const StyledDialog = styled(Dialog)`
  border-radius: 30px;
  transform: translateZ(0);
`;

const StyledDialogContent = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transform: translateZ(0);
`;

export type ModalProps = DialogProps & {
  children?: React.ReactNode | React.ReactNode[] | string;
  onClose?: () => void;
  open?: boolean;
  icon?: React.ReactNode;
};

export const Modal = ({ children, open, onClose, icon, ...props }: ModalProps) => {
  return (
    <StyledDialog open={open} onClose={onClose} {...props}>
      <StyledDialogContent>{children}</StyledDialogContent>
      <CloseButton onClick={onClose}>{icon}</CloseButton>
    </StyledDialog>
  );
};
